/** Pure vertex operations behind the map's polygon editor (spec §6.4). */
import type { LngLat } from '@/planner/types';

export type EditorMode = 'view' | 'draw' | 'edit' | 'takeoff';

export function addVertex(vs: LngLat[], p: LngLat): LngLat[] {
  return [...vs, p];
}

export function moveVertex(vs: LngLat[], i: number, p: LngLat): LngLat[] {
  return vs.map((v, j) => (j === i ? p : v));
}

/** Insert after `afterIndex`; `afterIndex === vs.length - 1` inserts on the closing edge. */
export function insertVertex(vs: LngLat[], afterIndex: number, p: LngLat): LngLat[] {
  return [...vs.slice(0, afterIndex + 1), p, ...vs.slice(afterIndex + 1)];
}

export function deleteVertex(vs: LngLat[], i: number): LngLat[] {
  return vs.length <= 3 ? vs : vs.filter((_, j) => j !== i);
}

export function midpoints(vs: LngLat[]): LngLat[] {
  const n = vs.length;
  const edges = n >= 3 ? n : Math.max(0, n - 1);
  return Array.from({ length: edges }, (_, i) => {
    const a = vs[i];
    const b = vs[(i + 1) % n];
    return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
  });
}
